import { CarouselActionTypes, CarouselActionsUnion } from './carousel.actions';
import { CarouselInitialState } from './carousel.state';

export function carouselReducer(
  state = CarouselInitialState,
  action: CarouselActionsUnion
) {
  switch (action.type) {
    case CarouselActionTypes.LOAD_CAROUSEL_CONFIG:
      return { ...state };
    case CarouselActionTypes.LOAD_CAROUSEL_CONFIG_SUCCESS:
      const { response } = action.payload;
      return {
        ...response
      };
    case CarouselActionTypes.LOAD_CAROUSEL_CONFIG_FAILURE:
      return {
        ...state,
        ...CarouselInitialState
      };
    default:
      return state;
  }
}
